import {IntermediatePart} from "../../intermediatePart";

export default class DecorSeat extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = "decor_seat";
    this.partName = "Decor Seat";
  }

  load(dbFeature) {
    return super.load_(dbFeature, new DecorSeat());
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.Globals.DecorSeat;
    }
  }
}
